import { app } from '../../../app';
import { Controller } from './user-directories.controller';

app.component('companyUserDirectories', {
    controller: Controller,
    templateUrl: require('./user-directories.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/user-directories/user-directories.component.js